

































import {Component, Vue, Watch} from 'vue-property-decorator';
import {IOrder} from '@/models/IOrder';
import {DataTableHeader} from 'vuetify';
import {getListOrders} from '@/services/OrderService';
import LineItemView from '@/components/LineItemView.vue';
import ShippingAddressView from '@/components/ShippingAddressView.vue';
import TrackingIdView from '@/components/TrackingIdView.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    LineItemView,
    ShippingAddressView,
    TrackingIdView,

  }
})
export default class OrdersTable extends Vue {
  protected loading: boolean = true;
  protected orders: IOrder[] = [];

  protected headers: DataTableHeader[] = [
    {text: 'Order', align: 'start', sortable: false, value: 'name', width: 80},
    {text: 'Date', align: 'start', sortable: false, value: 'name', width: 150, },
    {text: 'Items', align: 'start', sortable: false, value: 'name', width: 300, },
    {text: 'Shipping Address', align: 'start', sortable: false, value: 'name', },
    {text: 'Fulfillment', align: 'start', sortable: false, value: 'fulfillment_status', width: 150, },
    // { text: 'Tracking ID', align: 'start', sortable: false, value: 'name', width: 250, },
  ];

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  get shopId() {
    return ModuleShop.shopId;
  }


  @Watch(`shopId`, {immediate: true})
  public async loadData() {
    this.loading = true;
    try {
      this.orders = [];
      this.orders = await getListOrders(this.organizationId, this.shopId);
    } finally {
      this.loading = false;
    }
  }

}
